// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"0a762a56","453":"ed3810f9","626":"f4e3a1aa"}[chunkId] + ".chunk.js";
};